import { render } from "./HeaderBand.vue?vue&type=template&id=1004d241&scoped=true"
import script from "./HeaderBand.vue?vue&type=script&lang=js"
export * from "./HeaderBand.vue?vue&type=script&lang=js"

import "./HeaderBand.vue?vue&type=style&index=0&id=1004d241&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1004d241"]])

export default __exports__